module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.0.0.box.226.124.1012.256.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.18.0.0.box.226.124.796.196.q.70"
    }
  }, [_vm._v("CRIS BURNS' CARAMEL CAKE")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.18.0.1.box.230.332.1008.48.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ultimate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("caramel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("caramel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("icing ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.224.514.1263.386.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.18.1.0.box.226.514.349.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _vm._v("CARAMEL SYRUP")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.1.box.228.576.218.40.q.70"
    }
  }, [_vm._v("1 cup sugar")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.2.box.228.630.300.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _vm._v("1 cup hot water")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.3.box.224.736.1263.164.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.0.0"
    }
  }), _vm._v("Melt sugar over medium heat in an iron skillet. Slowly add hot water and simmer 5 to 10 minutes, stirring occasionally with a wooden spoon.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.18.2.0.box.225.944.1052.261.q.10"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0011.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.5.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.3.0.box.225.1258.1266.387.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.3.0.box.225.1258.1266.387.q.50"
    }
  }, [_vm._v("Cream butter and sugar, saving 5 tablespoons of sugar for later use. Add beaten egg yolks. Mix in 2 cups flour alternately with milk. Beat well. Add vanilla and 6 tablespoons caramel syrup."), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.5.1.0"
    }
  }), _vm._v(" Then add remaining ½ cup flour and baking powder. Fold in egg whites, beaten with remaining 5 tablespoons of sugar. Bake in buttered tube pan 40 to 45 minutes in 325° oven until done.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.18.4.0.box.225.1704.1000.156.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.8.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.8.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.5.0.box.228.1919.1266.383.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.5.0.box.228.1919.1266.383.q.60"
    }
  }, [_vm._v("Combine sugar, butter, and milk in a saucepan. Place candy thermometer on pan. Cook over medium heat until it comes to a boil. Add remainder of caramel syrup and cook to the soft ball stage on candy thermometer. Remove from heat; cool; add vanilla. Beat with a hand mixer or wooden spoon until spreading consistency. If it gets too thick, add a little cream. Ice the cooled cake.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.0.0.box.227.241.1273.282.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.0.0.box.227.241.1273.282.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grease ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pans, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("put ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("butter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("small ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("saucepan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("place ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("back ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("warm ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stove. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("When ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("melted, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("settle ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bottom; ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("butter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("then ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  }), _vm._v("clarified. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("before ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("putting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("batter, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("brush ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("butter, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dredge ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0"
    }
  }), _vm._v("thoroughly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flour, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("invert, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("remove ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("excess ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flour. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.19.1.0.box.232.674.1218.310.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0.2"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-937dfef8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0014.vue
// module id = 63
// module chunks = 0